<script setup lang="ts">
import { onBeforeUnmount, ref } from 'vue';

// Pinia
import Store from '@store/dataProvider';
import { storeToRefs } from 'pinia';

// Composables
import { useMessage } from '../../../composables/useMessage';
import { useToast } from '../../../composables/useToast';
import { useI18n } from 'vue-i18n'

// repositories
import TemplatesUIDataProviderRepository from '../../../repositories/templatesUI.repository';
const { t } = useI18n();
const { $toast } = useToast();
const { messageHTML, showMessage } = useMessage();

const store = Store();
const { templatesUI }: any = storeToRefs(store);

const templatesUIRepository = new TemplatesUIDataProviderRepository();

const emit = defineEmits<{
  (e: 'closeModal'): void;
}>();

const refTableForm = ref<any>(null);
const fields: any = ref([
  {
    key: 'name',
    title: t('global.nombre'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('ajustes.plantillasUI.modalCreateTemplate.nombre_de_la_plantilla'),
    value: null,
    cols: 12,
  },
  {
    key: 'urlDomain',
    title: t('ajustes.plantillasUI.modalCreateTemplate.url_de_dominio'),
    type: 'text',
    validations: {
      rules: {
        required: true,
        verifyExpreRegular: /^(ftp|http|https):\/\/[^ "]+(?<!\/)$/,
      },
	  messages: {
		required: t('global.es_obligatorio'),
	  },
    },
    placeholder: 'https://example.com',
    value: null,
    cols: 12,
  },
  {
    key: 'primaryColour',
    title: t('ajustes.plantillasUI.modalCreateTemplate.color_principal'),
    type: 'color',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('ajustes.plantillasUI.modalCreateTemplate.color_principal'),
    value: '#000',
    cols: 12,
  },
  {
    key: 'imagePath',
    title: t('ajustes.plantillasUI.modalCreateTemplate.logo'),
    type: 'file',
    placeholder: t('ajustes.plantillasUI.modalCreateTemplate.logo'),
    value: null,
    cols: 12,
    validations: {
      rules: {
        required: true,
        max: 1,
      },
	  messages: {
		required: t('global.es_obligatorio'),
	  },
    },
  },
]);

const handleOnSubmit = async ({ items, isFormValid }: any) => {
  if (!isFormValid) return;
  try {
    const { data } = await templatesUIRepository.createTemplate(items);
    store.setProp({ key: 'templatesUI', value: [...templatesUI.value, data] });
    $toast?.success(t('ajustes.plantillasUI.modalCreateTemplate.plantilla_creada_con_exito'));
    emit('closeModal');
  } catch (error: any) {
    showMessage(error.message, 'error');
  }
};

onBeforeUnmount(() => {
  fields.value.forEach((field: any) => {
    field.value = null;
  });
});
</script>

<template>
  <Form ref="refTableForm" :inputs="fields" @onSubmit="handleOnSubmit">
    <template #buttons>
      <div v-if="messageHTML" v-html="messageHTML" />
      <div class="d-flex">
        <CButton class="w-100 fs-6 p-2" background="background-blue">
          <template #content>
            <div>
              <span>{{ t("global.crear") }}</span>
            </div>
          </template>
        </CButton>
      </div>
    </template>
  </Form>
</template>
